import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Container, Link, Stack, Toolbar, Typography, useMediaQuery } from '@mui/material';

// project import
import menu from 'menu';
import AdminDrawer from './AdminDrawer';
import AdminHeader from './AdminHeader';

// ==============================|| MAIN LAYOUT (same structure as front-end) ||============================== //

const AdminLayout = () => {
  const theme = useTheme();
  const matchDownXL = useMediaQuery(theme.breakpoints.down('xl'));
  const { pathname } = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(!matchDownXL);

  // Collapse on narrower screens, expand on wide ones (front-end does the same).
  useEffect(() => {
    setDrawerOpen(!matchDownXL);
  }, [matchDownXL]);

  const current = menu.find((item) => item.url && pathname.startsWith(item.url));

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <AdminHeader open={drawerOpen} onToggle={() => setDrawerOpen((o) => !o)} title={current?.title ?? 'Admin Panel'} />
      <AdminDrawer open={drawerOpen} onToggle={() => setDrawerOpen((o) => !o)} />

      <Box component="main" sx={{ minWidth: 0, flexGrow: 1, p: { xs: 1.25, sm: 2 } }}>
        <Toolbar />
        <Container
          maxWidth="xl"
          sx={{
            px: { xs: 0.5, sm: 1.25, lg: 1.75 },
            py: { xs: 1.25, sm: 2, lg: 4.5 },
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '1280px !important'
          }}
        >
          <Outlet />
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: '24px 16px 0px', mt: 'auto' }}>
            <Typography variant="caption">&copy;{new Date().getFullYear()} NUWAY. All rights reserved.</Typography>
            <Stack spacing={1.5} direction="row" alignItems="center">
              <Link href="https://nuway.co" target="_blank" rel="noreferrer" variant="caption" color="textPrimary">
                About us
              </Link>
              <Link href="https://nuway.co/privacy-policy/" target="_blank" rel="noreferrer" variant="caption" color="textPrimary">
                Privacy
              </Link>
              <Link href="https://nuway.co/terms-and-conditions/" target="_blank" rel="noreferrer" variant="caption" color="textPrimary">
                Terms
              </Link>
            </Stack>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

export default AdminLayout;
